export const REVIEWERS_ACTIONS = {
    SET_REVIEWERS: "SET_REVIEWERS",
    SET_IS_LOADING: "SET_IS_LOADING",
}